var breakpoints = require('./navigation-breakpoints.js');

module.exports = function() {
  var width = window.innerWidth || window.document.documentElement.clientWidth;

  return width < breakpoints.sm;
};
